package br.com.texeratx.boardgametimeapp.ui.screens.dashboard.model

data class DashboardPlayerUI(
    val playerId: Long,
    val name: String,
    val nickname: String?,
    val imageUrl: String?,
    val wins: Int,
    val seconds: Int,
    val participations: Int,
    val winRate: Double,
    val secondRate: Double
)
